import { XR } from '@orderx/lab/xr';
import React from 'react';
import { OrderIdPageResult } from '../../../../pages/order/id/OrderIdPage';
import styled from 'styled-components';
import { Text } from '../../../text/Text';
import { BoxAnimation } from '../../../box-animation/BoxAnimation';
import { PathLike } from '@orderx/lab/xr/type';
import { RootIdPage } from '../../../../pages/id/RootIdPage';
import { OrderReceiptOrderProducts } from '../../receipt/order-products/OrderReceiptOrderProducts';
import { OrderProductStatus } from '../../../../XV2';
import clsx from 'clsx';
import { XIcon } from '@orderx/lab/ui';
import { Currency } from '../../../../services/currency/Currency';
import sum from 'lodash/sum';

const Wrapper = styled.div`
    padding: var(--XR-Section-padding);

    .grid {
        display: grid;
        grid-gap: var(--XR-Section-padding);
        padding: var(--XR-Section-padding);
    }

    .card-container {
        position: relative;
    }

    .check {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 1;
        font-size: 8rem;
        opacity: 0.75;
        color: blue !important;
    }

    .isAllProductsDelivered {
        background-color: var(--XR-color-success);

        * {
            color: white;
        }
    }

    .sequence {
        font-size: 10rem;
    }
`;

type Input = {
    result: OrderIdPageResult;
    linkBack?: PathLike;
};

export function OrderViewShowCode({ result, linkBack }: Input) {
    const dialog = XR.useDialog({
        toggleElement: <XR.Button fullWidth>Show details</XR.Button>,
        header: { title: 'Order details' },
        content: <OrderReceiptOrderProducts orderId={result.id} />,
    });

    const deliveredProducts = result.orderProducts.filter((item) => item.status === OrderProductStatus.DELIVERED);
    const isAllProductsDelivered = result.orderProducts.length === deliveredProducts.length;
    const amountTotal = sum(
        result.orderProducts
            .filter((item) => item.status !== OrderProductStatus.CANCELLED)
            .map((item) => item.priceCombined),
    );
    const CardContainer = isAllProductsDelivered ? XR.Card : BoxAnimation;

    return (
        <Wrapper>
            <XR.Box justify={'spaceBetween'}>
                <div />

                <XR.Button
                    icon={'close'}
                    to={linkBack || [RootIdPage.route, { id: result.zone.hash }]}
                    variant={'outlined'}
                />
            </XR.Box>

            <div className={'grid'}>
                <Text align={'center'}>Show this code to staff to get your order</Text>

                <CardContainer className={clsx('grid card-container', { isAllProductsDelivered })}>
                    <Text variant={'subtitle'} color={'textSecondary'} align={'center'}>
                        {result.outlet?.name || '-'} • {result.zone?.name || '-'}
                    </Text>

                    {isAllProductsDelivered && (
                        <>
                            <XIcon className={'check'}>check_circle_outline</XIcon>

                            <Text variant={'title'} align={'center'}>
                                Order has been handed out!
                            </Text>
                        </>
                    )}

                    <Text align={'center'} className={'sequence'}>
                        {result.sequence}
                    </Text>

                    <Text variant={'subtitle'} color={'textSecondary'} align={'center'}>
                        Total cost: {Currency().format(amountTotal)}
                    </Text>
                </CardContainer>
            </div>

            <XR.Section>{dialog.element}</XR.Section>
        </Wrapper>
    );
}
